import React from "react";
import InterviewSummary from "./InterviewSummary";
import HiringTrends from "./HiringTrends";
import TodayInterviews from "./TodayInterviews";

const DashboardLayout: React.FC = () => {
  return (
    <div className="grid grid-cols-3 gap-4  h-auto">
      <div className="col-span-2 space-y-2">
        <InterviewSummary />
        <HiringTrends />
      </div>
      <div>
        <TodayInterviews />
      </div>
    </div>
  );
};

export default DashboardLayout;
